import React from 'react';
import type { CohortStatus } from 'src/api/redux/providerCohorts';

interface CohortStatusLabelProps {
  status?: CohortStatus;
}

/**
 * Inline, colored status label for a cohort ("Encounters") item — surfaces
 * PROCESSING, ERROR, and DEACTIVATED as a parenthetical next to the type. Shared
 * across the selector dropdowns so the states read consistently; renders nothing
 * for READY or any other status.
 */
const CohortStatusLabel: React.FC<CohortStatusLabelProps> = ({ status }) => {
  if (status === 'PROCESSING') {
    return (
      <span className="ml-2 text-xs text-orange-500 italic">(In Progress)</span>
    );
  }

  if (status === 'ERROR') {
    return <span className="ml-2 text-xs text-red-500 italic">(Error)</span>;
  }

  if (status === 'DEACTIVATED') {
    return (
      <span className="ml-2 text-xs text-neutral-500 italic">(Deactivated)</span>
    );
  }

  return null;
};

export default CohortStatusLabel;
